import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, GetDataGridItemsResponse, SetFiltersRequest } from '../types';
import { GetRowsRequest, GetSummaryRequest, GetSummaryResponse, UpdateSettingsRequest, UpdateSettingsResponse } from '../../../grid/types/common';
import { sanitizeObject } from '../../../utils/sanitization.utils';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { getExclusionItemsRecords, getPayloadForReadRecords } from '../../exclusionItemGrid/helpers';
import { RpcAction, RpcExclusionItemsMethod } from '../../exclusionListItemsEditPanel/types';

export class GlobalExclusionsGzDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  response: any;
  limit = 50;

  constructor(public dependencies: any) {
    super();
  }

  public async readRecords(request): Promise<any> {
    const readRequestResponse = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload: getPayloadForReadRecords(request),
      endpoint: RpcAction.EXCLUSION_ITEMS,
      method: RpcExclusionItemsMethod.READ_RECORDS,
    });

    return getExclusionItemsRecords(readRequestResponse);
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    request.pageSize = this.limit;
    request.extraParams['companyId'] = Application.Main.getActiveCompany().id;
    const response = await this.readRecords(request);

    this.response = response;
    return sanitizeObject({
      summary: `${response.total} items`,
      numItems: response.total,
    });
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetDataGridItemsResponse> {
    let response = this.response;
    request.pageSize = this.limit;
    request.extraParams['companyId'] = Application.Main.getActiveCompany().id;

    if (!response) {
      response = await this.readRecords(request);
    } else {
      this.response = null;
    }

    return sanitizeObject({ rawEvents: response.data });
  }

  async setFilters(request: SetFiltersRequest): Promise<{} | undefined> {
    request.filters.forEach((filter, index) => {
      if (filter?.remarks?.regex) {
        filter.remarks.startsWith = filter.remarks.regex.pattern;
        delete filter.remarks.regex;
      }
      if (filter?.excludedItems?.regex) {
        filter.excludedItems.startsWith = filter.excludedItems.regex.pattern;
        delete filter.excludedItems.regex;
      }
    });
    return;
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    this.limit = request.pageSize ?? 50;
    return {};
  }

  shouldDataReloadOnResetView(): boolean {
    return true;
  }
}
